// extracted by mini-css-extract-plugin
export default {"link":"f71c65c23b4b2cc0","filters":"_467d5760b9002b0e"};